module.exports = __webpack_public_path__ + "img/seafarers-charity.446bb6c3.png";